import React from 'react'
import { Formik, FormikHelpers, Form } from 'formik'
import { AdminApi } from '../admin.api'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../../routes.constants'
import FixedPageTitle from '../components/fixed-page-title.component'
import { createEventSchema } from '../validation.schemas'
import { Container } from '../../shared/shared.styled'
import PrimaryButton from '../../shared/components/button.component'
import { useAlert } from 'react-alert'
import { useModal } from 'react-modal-hook'
import { ConfirmationModal } from '../../shared/components/modals/confirmation.modal'
import { CreateEventRequest } from '../admin.interfaces'
import EventFields from '../components/event-fields.component'

const CreateEventPage = () => {
    // Hooks Initialization
    const navigate = useNavigate()
    const alert = useAlert()

    const [showConfirmationModal, hideConfirmationModal] = useModal(
        () => (
            <ConfirmationModal
                title="Tem a certeza que quer sair"
                description="Vai perder toda a informação que modificou"
                onClick={() => {
                    hideConfirmationModal()
                    window.history.back()
                }}
                onCancel={hideConfirmationModal}
            />
        ),
        []
    )

    const getFormikInitialValues = (): CreateEventRequest => {
        return {
            name: '',
            startDate: '',
            endDate: '',
            imageUrl: '',
            active: true,
        }
    }

    const createEvent = async (
        values: CreateEventRequest,
        actions: FormikHelpers<CreateEventRequest>
    ) => {
        try {
            actions.setSubmitting(true)
            await AdminApi.methods.createEvent(values)
            navigate(RoutesEnum.EVENTS)
        } catch (e) {
            alert.error('Erro ao criar o evento. Por favor tente mais tarde')
        } finally {
            actions.setSubmitting(false)
        }
    }

    const checkIfFormIsDirtyAndClose = (isDirty: boolean) => {
        if (isDirty) {
            showConfirmationModal()
        } else {
            window.history.back()
        }
    }

    const renderButtons = (isSubmitting: boolean, isDirty: boolean) => (
        <>
            <PrimaryButton
                label="Cancelar"
                onClick={() => checkIfFormIsDirtyAndClose(isDirty)}
            />
            <PrimaryButton
                isLoading={isSubmitting}
                type="submit"
                label="Criar evento"
                redTheme={true}
            />
        </>
    )

    return (
        <Container>
            <Formik<CreateEventRequest>
                onSubmit={createEvent}
                initialValues={getFormikInitialValues()}
                validateOnChange={false}
                validationSchema={createEventSchema()}
                enableReinitialize={true}
            >
                {({ isSubmitting, handleSubmit, dirty }) => (
                    <Form
                        translate="yes"
                        onSubmit={isSubmitting ? () => null : handleSubmit}
                    >
                        <FixedPageTitle
                            label="Criar um novo evento"
                            rightButtons={renderButtons(isSubmitting, dirty)}
                        />

                        <EventFields isEditing={true} />
                    </Form>
                )}
            </Formik>
        </Container>
    )
}

export default CreateEventPage
